module.exports = __webpack_public_path__ + "img/seta_drt.0fccd6ba.svg";